import { createSlice } from '@reduxjs/toolkit';
import { deleteDropdownSettingApi } from '../../../rtk-apis/clinics/deleteDropdownSetting';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const deleteDropdownSettingSlice = createSlice({
  name: 'deleteDropdownSetting',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(deleteDropdownSettingApi.pending, state => {
        state.loading = true;
      })
      .addCase(deleteDropdownSettingApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(deleteDropdownSettingApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default deleteDropdownSettingSlice.reducer;
export const { clearState } = deleteDropdownSettingSlice.actions;
